import React from 'react';
import { useSession } from 'next-auth/client';
import Layout from '../components/layout';
import AccessDenied from '../components/access-denied';
import WithGraphQL from '../lib/with-graphql';
import PageContent from '../components/protected-comp';
import { getSession } from 'next-auth/client';

export default function Page() {
  const [session, loading] = useSession();

  // When rendering client side don't display anything until loading is complete
  if (typeof window !== 'undefined' && loading) return null;

  // If no session exists, display access denied message
  if (!session) {
    return (
      <Layout>
        <AccessDenied />
      </Layout>
    );
  }

  // If session exists, display content
  return (
    <WithGraphQL session={session}>
      <Layout>
        <PageContent/>
      </Layout>
    </WithGraphQL>
  );
}

export async function getServerSideProps(context) {
  const session = await getSession(context);

  return {
    props: {
      session
    }
  };
}